// extracted by mini-css-extract-plugin
export var details = "_dl-0";
export var inspectorPopover = "_dl-1";